const organizations = {
    title: 'Организации',
    description: 'Создавайте организации и управляйте организациями, в которых состоите.',
    create: 'Создать организацию',
    create_title: 'Создать новую организацию',
    name: 'Название организации',
    avatar: 'Аватар организации',
    avatar_removed: 'Аватар организации удалён.',
    description_label: 'Описание',
    empty: 'Вы пока не состоите ни в одной организации.',
    pending_invitations: 'Ожидающие приглашения',
    accept: 'Принять',
    decline: 'Отклонить',
    owner: 'Владелец',
    tabs: {
        overview: 'Обзор',
        members: 'Участники',
        invitations: 'Приглашения',
        roles: 'Роли управления',
        branding: 'Оформление',
        security: 'Безопасность',
        jit: 'JIT-подготовка',
        applications: 'Общие ресурсы',
        activity: 'Активность',
        deletion: 'Удаление',
    },
    members: {
        title: 'Участники',
        empty: 'Участники не найдены.',
        remove: 'Удалить',
        removed: 'Участник удалён.',
        business_roles: 'Бизнес-роли',
        no_business_roles: 'Нет доступных бизнес-ролей. Попросите администратора тенанта предоставить роли этой организации.',
    },
    invitations: {
        title: 'Приглашения',
        invite: 'Пригласить участника',
        email: 'Адрес электронной почты',
        empty: 'Приглашения не найдены.',
        resend: 'Отправить повторно',
        resent: 'Приглашение отправлено повторно.',
        revoke: 'Отозвать',
        revoked: 'Приглашение отозвано.',
        status: {
            Pending: 'Ожидает ответа',
            Accepted: 'Принято',
            Expired: 'Истекло',
            Revoked: 'Отозвано',
            Declined: 'Отклонено',
        },
    },
    roles: {
        title: 'Роли управления',
        create: 'Создать роль',
        permissions: 'Разрешения',
        empty: 'Роли управления не найдены.',
        select_member: 'Выбрать участника',
        select_role: 'Выбрать роль',
        assign: 'Назначить роль',
        assigned: 'Роль назначена.',
        unassign: 'Снять роль',
        unassigned: 'Роль снята.',
        permission_count: 'Разрешений: {{count}}',
        built_in: {
            owner: 'Владелец',
            owner_description: 'Владельцы имеют исключительные права на управление владением и удаление организации.',
            administrator: 'Администратор',
            administrator_description: 'Управляет организацией, кроме действий, доступных только владельцам.',
        },
        permission_labels: {
            update_profile: 'Изменение профиля',
            manage_branding: 'Управление оформлением',
            view_members: 'Просмотр участников',
            manage_members: 'Управление участниками',
            manage_invitations: 'Управление приглашениями',
            assign_business_roles: 'Назначение бизнес-ролей',
            manage_management_roles: 'Управление ролями управления',
            assign_management_roles: 'Назначение ролей управления',
            manage_security: 'Управление безопасностью',
            manage_jit: 'Управление JIT-подготовкой',
            manage_applications: 'Управление приложениями',
            view_activity: 'Просмотр активности',
        },
    },
    branding: {
        title: 'Оформление организации',
        primary_color: 'Основной цвет',
        custom_css: 'Пользовательский CSS',
        preview: 'Предпросмотр',
        light: 'Светлая',
        dark: 'Тёмная',
    },
    security: {
        title: 'Безопасность организации',
        require_mfa: 'Требовать многофакторную аутентификацию для участников',
    },
    jit: {
        title: 'Почтовые домены JIT',
        domain: 'Почтовый домен',
        add: 'Добавить домен',
        verify: 'Проверить DNS',
        dns_instruction: 'Создайте запись TXT {{record}} со значением {{value}}.',
        verified: 'Подтверждён',
    },
    applications: {
        title: 'Общие ресурсы',
        empty: 'Для этой организации нет доступных ресурсов.',
        sso: 'Корпоративные SSO-подключения',
        m2m: 'Межмашинные приложения',
    },
    activity: {
        title: 'Активность организации',
        empty: 'Пока нет активности.',
        events: {
            create: 'Организация создана',
            delete: 'Организация удалена',
            profile: 'Профиль организации обновлён',
            branding: 'Оформление организации обновлено',
            security: 'Безопасность организации обновлена',
            member_add: 'Участник добавлен',
            member_remove: 'Участник удалён',
            owner: 'Владение организацией изменено',
            role_create: 'Роль управления создана',
            role_update: 'Роль управления обновлена',
            role_delete: 'Роль управления удалена',
            role_assign: 'Роль управления назначена',
            role_unassign: 'Роль управления снята с участника',
            business_role: 'Бизнес-роли обновлены',
            invitation_create: 'Приглашение отправлено',
            invitation_accept: 'Приглашение принято',
            invitation_decline: 'Приглашение отклонено',
            invitation_revoke: 'Приглашение отозвано',
            jit: 'JIT-подготовка обновлена',
            domain: 'Подтверждение почтового домена',
            application: 'Подключения приложений обновлены',
            unknown: 'Активность организации',
        },
    },
    save: 'Сохранить изменения',
    cancel: 'Отмена',
    delete: 'Удалить организацию',
    delete_confirmation: 'Организация и её связи с участниками будут удалены навсегда. Введите «{{name}}» для подтверждения.',
    deleted: 'Организация удалена.',
    load_failed: 'Не удалось загрузить данные организации. Повторите попытку.',
    permission_denied: 'У вас нет разрешения на просмотр этого раздела.',
};
export default organizations;
